<template>
    <basic-card>
        <template slot="header">Job schedule</template>
            <form-wrapper>
                <form-text-input caption="Display name" v-model="jobSchedule.displayName"/>
                <form-select-input caption="Job" :options="jobDefinitionOptions" v-model="jobSchedule.definitionId"/>
                <form-checkbox-input caption="Active" v-model="jobSchedule.active"/>
                <form-select-input caption="Frequency" v-model="jobSchedule.type" :options="jobScheduleTypes"/>
                <template v-if="jobSchedule.type == 'INTERVAL'">
                    <form-number-input caption="Interval [minutes]" v-model="jobSchedule.intervalMinutes"/>
                </template>
                <template v-else>
                    <form-checkbox-input caption="Monday" v-model="tempDays[0]"/>
                    <form-checkbox-input caption="Tuesday" v-model="tempDays[1]"/>
                    <form-checkbox-input caption="Wednesday" v-model="tempDays[2]"/>
                    <form-checkbox-input caption="Thursday" v-model="tempDays[3]"/>
                    <form-checkbox-input caption="Friday" v-model="tempDays[4]"/>
                    <form-checkbox-input caption="Saturday" v-model="tempDays[5]"/>
                    <form-checkbox-input caption="Sunday" v-model="tempDays[6]"/>
                    <form-text-input caption="Time" v-model="jobSchedule.time"/>
                </template>
<!--                <form-text-input caption=""-->

<!--                private BitSet days = new BitSet(7);-->
<!--                private LocalTime time;-->
<!--                private Integer intervalMinutes;-->
<!--                private JobScheduleType type;-->

<!--                private LocalDateTime lastRunTime;-->
            </form-wrapper>
        <simple-button confirmation-protected
                       :protection-message="`saving of job schedule`"
                       @proceed="handleSave">
            Save</simple-button>
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import FormWrapper from "../components/form/FormWrapper";
    import FormSelectInput from "../components/form/FormSelectInput";
    import FormCheckboxInput from "../components/form/FormCheckboxInput";
    import FormTextInput from "../components/form/FormTextInput";
    import FormNumberInput from "../components/form/FormNumberInput";
    import SimpleButton from "../components/button/SimpleButton";
    import {mapGetters} from "vuex";
    export default {
        name: "ScheduledJobCard",
        components: {
            SimpleButton,
            FormNumberInput, FormTextInput, FormCheckboxInput, FormSelectInput, FormWrapper, BasicCard},
        props: {
            jobSchedule: Object
        },
        data() {
            return {
                tempDays: new Array(7).fill(false)
            }
        },
        computed: {
            jobScheduleTypes() {
                return [{name: "Once a day", id: "DAILY"}, {name: "Interval", id: "INTERVAL"}]
            },
            jobDefinitionOptions() {
                return this.importDefinitions.filter(def => def.type == 'JOB')
                .map(def => ({
                    name: def.displayName,
                    id: def.id
                }))
            },
            ... mapGetters({
                importDefinitions: 'importDefinitions/importDefinitions'
            })
        },
        methods: {
            handleSave() {
                this.jobSchedule.days = this.tempDays.map((val, idx) => ({value: val, index: idx + 1}))
                    .filter(val => val.value)
                    .map(val => val.index);
                if(this.jobSchedule.time != null)
                    this.jobSchedule.time += ":00"
                this.$emit('save', this.jobSchedule)
            }
        },
        watch: {
            jobSchedule: {
                immediate: true,
                handler(newVal, oldVal) {
                    newVal.time = newVal.time.substring(0, 5);
                    this.tempDays.fill(false);
                    if(newVal.days != null && newVal.days != undefined) {
                        newVal.days.forEach(day => this.tempDays[day - 1] = true);
                    }

                }
            }
        }
    }
</script>

<style scoped>

</style>
